"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BudgetToJSON = exports.BudgetFromJSONTyped = exports.BudgetFromJSON = exports.instanceOfBudget = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the Budget interface.
 */
function instanceOfBudget(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBudget = instanceOfBudget;
function BudgetFromJSON(json) {
    return BudgetFromJSONTyped(json, false);
}
exports.BudgetFromJSON = BudgetFromJSON;
function BudgetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'microAmount': !(0, runtime_1.exists)(json, 'micro_amount') ? undefined : json['micro_amount'],
        'currency': !(0, runtime_1.exists)(json, 'currency') ? undefined : json['currency'],
    };
}
exports.BudgetFromJSONTyped = BudgetFromJSONTyped;
function BudgetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'micro_amount': value.microAmount,
        'currency': value.currency,
    };
}
exports.BudgetToJSON = BudgetToJSON;
